import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepoService } from '../shared/services/repo.service';
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [RepoService]
})
export class SharedModule { }
  